"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawUntilPlayableLimit = exports.DefaultGameRules = void 0;
exports.DefaultGameRules = {
    noStacking: false,
    drawUntilPlayable: false,
    sevenZero: false,
};
exports.DrawUntilPlayableLimit = 10;
